<template>
  <div class="page" :style="bgStyle">
    <div class="contenido">
      <p class="subtitulo">Encuesta de satisfacción</p>
      <img
        src="/mexa/boton-descarga-encuesta.png"
        class="btn-img"
        :class="{ cargando: loading }"
        alt="Descargar reporte"
        @click="!loading && descargar()"
      />
      <p v-if="loading" class="loading-msg">Descargando...</p>
      <p v-if="error" class="error-msg">{{ error }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EncuestaReporte',
  data() {
    return { loading: false, error: '', isMobile: window.innerWidth <= 768 }
  },
  computed: {
    bgStyle() {
      const img = this.isMobile ? '/mexa/fondo-movil.jpg' : '/mexa/fondo-encuesta.jpg'
      return {
        backgroundImage: `url(${img})`,
        backgroundSize: 'cover',
        backgroundPosition: 'top center',
        backgroundRepeat: 'no-repeat',
        backgroundColor: '#009fe3'
      }
    }
  },
  mounted()       { window.addEventListener('resize', () => { this.isMobile = window.innerWidth <= 768 }) },
  beforeDestroy() { window.removeEventListener('resize', () => {}) },
  methods: {
    async descargar() {
      this.loading = true
      this.error = ''
      try {
        const res = await this.$api.get('encuesta-convencion26/excel', { responseType: 'blob' })
        const url = window.URL.createObjectURL(new Blob([res.data]))
        const a = document.createElement('a')
        a.href = url
        a.download = 'reporte-encuesta-convencion26.xlsx'
        a.click()
        window.URL.revokeObjectURL(url)
      } catch {
        this.error = 'Error al descargar el reporte. Intenta de nuevo.'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.contenido {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding-top: clamp(200px, 35vh, 380px);
  gap: 16px;
  transform: translateX(clamp(0%, 15%, 15%));
}

.subtitulo {
  color: rgba(255,255,255,0.92);
  font-size: clamp(16px, 2vw, 22px);
  font-family: TelefonicaRegular, sans-serif;
  margin: 0;
}

.btn-img {
  height: clamp(48px, 6vw, 64px);
  width: auto;
  cursor: pointer;
  transition: transform 0.15s, filter 0.15s;
}
.btn-img:hover    { transform: scale(1.05); filter: brightness(1.1); }
.btn-img:active   { transform: scale(0.97); }
.btn-img.cargando { opacity: 0.6; cursor: not-allowed; }

.loading-msg { color: rgba(255,255,255,0.85); font-size: 13px; margin: 0; }
.error-msg   { color: #fff; font-size: 13px; margin: 0; }

/* TABLET */
@media (max-width: 1200px) {
  .contenido { padding-top: 270px; transform: translateX(10%); }
}

/* MOBILE */
@media (max-width: 768px) {
  .contenido  { padding-top: clamp(160px, 42vh, 280px); transform: translateX(0); align-items: center; }
  .subtitulo  { font-size: 16px; }
  .btn-img    { height: 52px; }
}
</style>
